import { createAuthClient } from "better-auth/react";
import {
  inferAdditionalFields,
  organizationClient,
} from "better-auth/client/plugins";
import { ac, admin, member } from "~server/lib/permissions";
import type { auth } from "~server/lib/auth.server";

/**
 * ⛔⛔ `ENV` IS A BROWSER GLOBAL, AND THIS MODULE IS ALSO IN THE SERVER BUNDLE.
 * The root loader builds `ENV` and `root.tsx` writes it to `window.ENV`, so on
 * the client the bare global resolves. On the SERVER nothing declares it —
 * `declare global { var ENV: ENV }` types it for TypeScript and creates
 * nothing at runtime — so evaluating this module during SSR threw
 * "ENV is not defined". It is evaluated there: `baseURL: ENV.BETTER_AUTH_URL`
 * is compiled verbatim into build/server/index.js, and this is the only bare
 * module-scope read of that global left in the app.
 *
 * ⭐ SO THE VALUE IS READ FROM WHICHEVER SIDE IS ACTUALLY RUNNING, and neither
 * read assumes the other's globals exist. Same value on both: the client's
 * `window.ENV.BETTER_AUTH_URL` IS `process.env.BETTER_AUTH_URL`, handed over by
 * the root loader (server/lib/env.ts `getEnv`).
 *
 * ⛔ No provider and no config system is introduced — this reads the env the
 * app already has. When neither side has a value, `baseURL` is left undefined
 * and better-auth addresses the page's own origin, which is the right
 * behaviour for a same-origin app and is what makes signed-in QA work on any
 * port once the variable is set at server start.
 */
const authBaseURL =
  typeof globalThis.ENV !== "undefined"
    ? globalThis.ENV.BETTER_AUTH_URL
    : typeof process !== "undefined"
      ? process.env.BETTER_AUTH_URL
      : undefined;

export const authClient = createAuthClient({
  //you can pass client configuration here
  baseURL: authBaseURL,
  plugins: [
    organizationClient({
      ac,
      roles: {
        admin,
        member,
      },
    }),
    inferAdditionalFields<typeof auth>(),
  ],

  // This isn't working even if we import the auth server as a 'type'
  // plugins: [inferAdditionalFields<typeof auth>()],
  /**
   * If we can't find ways to infer additional fields 
   * like what we did in the auth server, we have to ignore 
   * type errors when using the additional fields
   * Example:
      await authClient.signUp.email(
        {
          email: data.email,
          password: data.password,

          //@ts-ignore
          role: UserRole.SUPER_ADMIN,
        }
      );
   */
});
